import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function runDensityAudit(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_density_audit`)
}
export function getDensityAudit(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/density_audit`)
}
export function approveAuditFixes(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_audit_fixes`)
}
